import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../styles.css';

const ForgotPassword = () => {
    const [contactNumber, setContactNumber] = useState('');
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
  
    const handleContactNumberChange = (e) => {
      setContactNumber(e.target.value);
      if (error) setError(null);
      if (success) setSuccess(null);
    };
  
    const handleSendOtp = async (e) => {
      e.preventDefault();
      setIsLoading(true);
      setError(null);
      setSuccess(null);
      
      try {
        const response = await axios.post('https://attend.teamhalt.com/attendence/api/v1/forget-password/', { contact_number: contactNumber });
        //const response = await axios.post('http://127.0.0.1:8000/attendence/api/v1/forget-password/', { contact_number: contactNumber });
        if (response.data.message) {
          setSuccess(response.data.message);
          setTimeout(() => {
            navigate('/reset-password', { state: { contactNumber } });
          }, 1500);
        } else {
          setError('Failed to send OTP. Please try again.');
        }
      } catch (error) {
        console.error('Error sending OTP:', error);
        setError('Error sending OTP. Please try again.');
      } finally {
        setIsLoading(false);
      }
    };

  return (
    <div className="auth-wrapper">
      <div className="auth-left-section">
        <div className="auth-header">
          <div className="auth-brand-logo">
            {/* <span className="logo-icon">⏱</span> */}
            <img src="/Teamhalt.png" alt="TeamHalt" className="logo-icon" />
            <span className="logo-text">TeamHalt</span>
          </div>
        </div>
        
        <div className="auth-brand-content">
          <h1>Password Recovery</h1>
          <p>Don't worry! Enter your contact number and we'll send you an OTP to reset your password.</p>
          <div className="auth-features">
            <div className="feature-item">
              <span className="feature-icon">✓</span>
              <span>Secure Password Reset</span>
            </div>
            <div className="feature-item">
              <span className="feature-icon">✓</span>
              <span>Instant OTP Verification</span>
            </div>
            <div className="feature-item">
              <span className="feature-icon">✓</span>
              <span>24/7 Account Support</span>
            </div>
          </div>
        </div>
        
        <div className="auth-footer">
          <Link to="/privacy-policy" className="privacy-link">Privacy Policy</Link>
          <p className="copyright">© 2026 TeamHalt. All rights reserved.</p>
        </div>
      </div>
      
      <div className="auth-right-section">
        <div className="auth-card">
          <div className="auth-header-form">
            <div className="form-icon">🔐</div>
            <h2>Forgot Password?</h2>
            <p>Enter your contact number to receive OTP</p>
          </div>
          
          <form onSubmit={handleSendOtp} className="auth-form-container">
            <div className="form-group">
              <label htmlFor="contactNumber">Contact Number</label>
              <div className="input-wrapper">
                {/* <span className="input-icon">📱</span> */}
                <input
                  type="tel"
                  id="contactNumber"
                  placeholder="Enter your contact number"
                  value={contactNumber}
                  onChange={handleContactNumberChange}
                  required
                  autoComplete="tel"
                />
              </div>
            </div>
            
            {error && (
              <div className="auth-error">
                <span className="error-icon">⚠</span>
                <span>{error}</span>
              </div>
            )}
            
            {success && (
              <div className="auth-success">
                <span className="success-icon">✓</span>
                <span>{success}</span>
              </div>
            )}
            
            <button 
              type="submit" 
              className="auth-button"
              disabled={isLoading}
            >
              {isLoading ? (
                <span className="loading-spinner"></span>
              ) : (
                'Send OTP'
              )}
            </button>
          </form>
          
          <div className="auth-footer-form">
            <Link to="/" className="back-login-link">
              <span>←</span> Back to Login
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;

